import ReactQuill from 'react-quill-new'
import { reactQuillFormats, reactQuillModules } from '../../../../utils/editor/reactQuill'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import SchoolRecordInput from './SchoolRecordInput'
import HtmlPrintBox from '../../../admin/common/HtmlPrintBox'

const TeacherCommentsTable = ({ register, control, grade, semester, isRead = false }) => {

    const defaultValue = {
        subject: '',
        teacher: '',
        comment: ''
    }

    const { fields, append, remove } = useFieldArray({
        control,
        name: `teacherComments.grade${grade}.semester${semester}`,
    });


    return (
        <div>
            <table className='table table-sm table-bordered text-center align-middle mb-0'>
                <thead>
                    <tr>
                        <th style={{ width: "160px" }}>SUBJECTS</th>
                        <th style={{ width: "120px" }}>TEACHER</th>
                        <th style={{ width: "auto" }}>Semester {semester}</th>
                        {!isRead && <th style={{ width: "60px" }}></th>}
                    </tr>
                </thead>

                <tbody>
                    {fields.map((field, index) => {
                        return (
                            <tr key={field.id}>
                                <td>
                                    <SchoolRecordInput register={register} name={`teacherComments.grade${grade}.semester${semester}.${index}.subject`} isRead={isRead} />
                                </td>
                                <td>
                                    <SchoolRecordInput register={register} name={`teacherComments.grade${grade}.semester${semester}.${index}.teacher`} isRead={isRead} />
                                </td>
                                <td>
                                    <Controller
                                        name={`teacherComments.grade${grade}.semester${semester}.${index}.comment`}
                                        control={control}
                                        render={({ field }) => (
                                            isRead
                                                ? <HtmlPrintBox value={field.value} />
                                                : <ReactQuill
                                                    theme="snow"
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                    modules={reactQuillModules}
                                                    formats={reactQuillFormats}
                                                    style={{ height: '300px', marginBottom: '80px' }}
                                                />
                                        )}
                                    />
                                </td>
                                {!isRead
                                    && <td>
                                        <button type='button' className='btn btn-sm btn-outline-danger' onClick={() => { remove(index) }}>삭제</button>
                                    </td>
                                }
                            </tr>
                        )
                    })}

                    {!isRead &&
                        <tr>
                            <td colSpan={4}>
                                <button
                                    type="button"
                                    className={`btn btn-sm btn-outline-primary`}
                                    onClick={() => append(defaultValue)}
                                >추가</button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default TeacherCommentsTable